/**
 * [web] 管理员首页选择。
 * Boundary: 根据会话权限选择已有管理页面，不授予额外的访问权限。
 */
import { canManagePluginStore } from '../../../shared/domain/plugin-access.ts';

export function adminHomePath(
  permissions: readonly string[],
  role: string | undefined,
): string | null {
  if (permissions.includes('user:manage')) return '/admin?tab=users';
  if (permissions.includes('role:manage')) return '/admin?tab=roles';
  if (permissions.includes('usage:read')) return '/usage';
  if (permissions.includes('relay:read')) return '/relays';
  if (canManagePluginStore(permissions, role)) return '/extensions/dsh';
  if (permissions.includes('config:manage')) return '/settings/general';
  if (permissions.includes('rule:manage')) return '/rules';
  return null;
}
